<template>
  <BranchAreaReport
      :items="items"
      :pfilters="$route.params.filters"
      :region-id="$route.params.regionId"
      @updated="onUpdate"
  />
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import ReportService from "@/services/report.service"
import _ from "underscore"
import Mapper from "@/mappers"
import Moment from "moment";
import {AllowStatistics} from "@/enums/permission";
import BranchAreaReport from "@/components/report/BranchStatistics/BranchAreaReportComponent.vue";

export default {
  name: "BranchAreaReportView",
  components: {
    BranchAreaReport
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      let regionId = this.$route.params.regionId;
      const {start, end, date, selectedFilters, selectedAreas, isAllClientsSelected, isArchive, clients} = filters;
      if (selectedFilters && selectedFilters.includes(3) && !selectedFilters.includes(2)) {
        selectedFilters.push(2);
      }

      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getBranchAreaReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        regionId : regionId,
        date: date ? Moment(date, "YYYY-MM") : null,
        selectedFilters: selectedFilters ? selectedFilters : null,
        selectedAreas: selectedAreas ? selectedAreas : null,
        isAllClientsSelected: isAllClientsSelected,
        type: isArchive,
        clients: clients
      })
          .then(response => {
            this.items = _.map(response.data, rvm => {
              return {
                area: Mapper.mapArea(rvm.Area),
                received: rvm.Received,
                printedForPeriodNormal: rvm.PrintedForPeriodNormal,
                restForPeriodEnd: selectedFilters ?
                    (rvm.Received !== null && rvm.PrintedForPeriodNormal !== null ?
                        (rvm.Received - rvm.PrintedForPeriodNormal) : null) : null,
                deletedFromPostPackageCount: rvm.DeletedFromPostPackageCount,
                postPackedForPeriod: rvm.PostPackedForPeriod,
                deliveredFromPacked: rvm.DeliveredFromPacked,
                returnedFromPacked: rvm.ReturnedFromPacked,
                postPackedNotPerformed: rvm.PostPackedNotPerformed,
                tryPerform: rvm.TryPerformCount,
                expiredCount: rvm.ExpiredCount,
                successDeliveredAfterFailedCount: rvm.SuccessDeliveredAfterFailedCount
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика филиалов по районам")
    }
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>
